import { useEffect, useState } from 'react';
import { FaRegCheckSquare } from "react-icons/fa";
import { IoSend } from "react-icons/io5";
import Layout from "../Layout";
import M from 'materialize-css/dist/js/materialize.min';
import { Helmet } from 'react-helmet';
import { ImCross } from 'react-icons/im';
import * as EmailValidator from 'email-validator';
import emailjs from 'emailjs-com';

const Contact = () => {
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [ error, setError ] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();

        //document.getElementById('Btn').innerHTML = 'Sending';

        if(name !== '' || surname !== '' || email !== '' || message !== '') {
            setError(null);
            if(!EmailValidator.validate(email)){
                setError('Please provide a valid email.');
            } else {
                setError(null);
                document.getElementById('Btn').classList.add('is-loading');

                //emailjs
                emailjs.sendForm('service_mub22jz', 'template_adejdrd', e.target, 'user_KoNMSajGWXzs1PJtgzR6h')
                .then((result) => {
                    //reset form 
                    setName('')
                    setEmail('');
                    setSurname('');
                    setPhone('');
                    setMessage('');

                    //on success
                    var successModal = document.getElementById('successModal');
                    var instance = M.Modal.init(successModal, {});
                    instance.open();

                    document.getElementById('Btn').classList.remove('is-loading');
                    //console.log(result.text);
                }, (error) => {
                    setError(error.text);
                    document.getElementById('Btn').classList.remove('is-loading');
                    //console.log(error.text);
                 });

               
            }
        } else {
            setError('Please fill out all the form fields.')
        }
    }
    useEffect(() => {
       // //modal init
       var elems = document.querySelectorAll('.modal');
       M.Modal.init(elems, {

       });
    }, [])

    return ( 
        <Layout>
            <Helmet> 
                <meta
                    name="description"
                    content="View our campus images and education material."
                />
                <title>Contact Us</title>
            </Helmet>
            <div className="light-bg">
                <div className="placeholder"></div>
                <div className="container">
                    <div className="topic-cont">
                        <span className="is-size-6-touch is-size-5-desktop grey-text text-lighten-3">Contact Us</span>
                    </div>
                    <div className="row">
                        <div className="col s12 m5 l4">
                            <h6 className="subtitle has-text-weight-semibold mt-5 mb-2">For More Information Contact</h6>
                            <div  className="mb-5">
                                <h6 className="has-text-weight-bold">Postal Address</h6>
                                <p>The Principal Life Long Polytechnic</p>
                                <p>89 Rotten Row </p>
                                <p>Harare</p>
                                <p>Zimbabwe</p>
                            </div>
                            <div className="mb-5">
                                <h6 className="has-text-weight-bold">Contact Numbers</h6>
                                <p><a href="tel:+263 78 762 5134" className="grey-text text-darken-2">+263 78 762 5134</a></p>
                                <p><a href="tel:+263 71 921 6324" className="grey-text text-darken-2">+263 71 921 6324</a></p>
                            </div>
                            <div className="mb-5">
                                <h6 className="has-text-weight-bold">Email</h6>
                                <p><a href="mailto:info@lifelongpolytechnic.co.zw" className="grey-text text-darken-2">info@lifelongpolytechnic.co.zw</a></p>
                                <p><a href="mailto:admin@lifelongpolytechnic.co.zw" className="grey-text text-darken-2">admin@lifelongpolytechnic.co.zw</a></p>
                            </div>
                        </div>
                        <div className="col s12 m5 l7 offset-l1">
                            <form className="box mt-5" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="input-field col s12 m6">
                                        <input name="user_name" id="name" type="text" onChange={(e) => setName(e.target.value)} value={name} required/>
                                        <label htmlFor="name">First Name</label>
                                    </div>
                                    <div className="input-field col s12 m6">
                                        <input name="user_surname" id="surname" type="text" onChange={(e) => setSurname(e.target.value)} value={surname} required />
                                        <label htmlFor="surname">Surname</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field col s12 m6">
                                        <input name="user_email" id="email" type="email"  className="validate" onChange={(e) => setEmail(e.target.value)} value={email} required />
                                        <label htmlFor="email">Email</label>
                                    </div>
                                    <div className="input-field col s12 m6">                   
                                        <input name="telephone" id="telephone" type="tel" onChange={(e) => setPhone(e.target.value)} value={phone}  />
                                        <label htmlFor="telephone">Phone Number</label>
                                    </div>
                                </div>
                                <div className="input-field col s12 m6 hide">                   
                                    <input name="mairi" type="text" defaultValue="nmctutorials45@gmail.com"/>
                                </div>

                                <div className="input-field col s12">
                                    <textarea name="message" id="textarea1" className="materialize-textarea" onChange={(e) => setMessage(e.target.value)} value={message} required></textarea>
                                    <label htmlFor="textarea1">Message</label>
                                </div>
                                {
                                    error && <p className="main-color-text tiny-text mt-5">{error}</p>
                                }
                                <div className="center">
                                    <button id="Btn" className="button is-rounded main-color my-3 border-none">
                                        <span className="icon">
                                            <IoSend color="white"/>
                                        </span>
                                        <span className="white-text">Send Message</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <h5 className="title has-text-weight-bold mt-6 mb-5"><span className="has-text-weight-light">Our</span> Location</h5>
                    <div className="divider"></div>

                    <div className="map-cont row py-6">
                        <div className="col s12 m8 l10 offset-m2 offset-l1">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3798.085878395181!2d31.036686814034578!3d-17.834608681175467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1931a4f768001f09%3A0xc442ef934c915993!2sLife%20Long%20Education%20College!5e0!3m2!1sen!2szw!4v1624980451586!5m2!1sen!2szw"  height="350" title="map" allowFullScreen loading="lazy"></iframe>
                        </div>
                    </div>
                </div>  
            </div>    
            {/* modal */}
            <div id="successModal" className="modal smooth-edge-2">
                <div className="modal-content center"> 
                    <FaRegCheckSquare fontSize="3rem" className="mt-4 make-green"/>
                    <h4 className=" is-size-4-touch is-size-3-desktop grey-text text-darken-2 mt-3 has-text-weight-semibold">Email Received</h4>
                    <p className="grey-text text-darken-1 is-size-6 mt-4">Thank you for getting in touch, our team will respond to email soon.</p>           
                </div>
                <div className="modal-footer">
                    <a href="#!" className="modal-close main-color button">Close</a>
                </div>
            </div>
            <div id="errorModal" className="modal smooth-edge-2">
                <div className="modal-content center"> 
                    <ImCross fontSize="3rem" className="mt-4 main-color-text"/>
                    <h4 className=" is-size-4-touch is-size-3-desktop grey-text text-darken-2 mt-3 has-text-weight-semibold">Error Occured</h4>
                    <p className="grey-text text-darken-1 is-size-6 mt-4">Sorry email couldn't be sent, Please ty again.</p>           
                </div>
                <div className="modal-footer">
                    <a href="#!" className="modal-close main-color button">Close</a>
                </div>
            </div>
        </Layout>
     );
}
 
export default Contact;